module.exports = __webpack_public_path__ + "img/app.ab1b1308.png";